import moment from "moment";
import router from "../router";

export default {
    loadAuthFromStorage(context) {
        let token = localStorage.getItem('token');
        let user = localStorage.getItem('user');

        if (token) {
            context.commit('setToken', token);
        }

        if (user) {
            context.commit('setUser', JSON.parse(user));
        }
    },
    setAuth(context, auth) {
        return new Promise((resolve) => {
            let session_expires_at = moment().add(auth.expiration_days, 'days');
            localStorage.setItem('session_expires_at', session_expires_at);
            localStorage.setItem('token', auth.token);
            localStorage.setItem('user', JSON.stringify(auth.user));
            context.commit('setToken', auth.token);
            context.commit('setUser', auth.user);
            context.commit('setSessionExpiration', session_expires_at);
            resolve();
        });
    },
    logout(context) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('session_expires_at');
        context.commit('setToken', null);
        context.commit('setUser', null);
        context.commit('setSessionExpiration', null);
        router.push('/login');
        window.location.href = '/';
    },
    setUrls(context) {
        context.commit('setWebappUrl', process.env.VUE_APP_WEBAPP_URL);
    },
    loadRecentAnimes(context) {
        const recent_animes = localStorage.getItem('recent_animes');
        const recents_expires_at = localStorage.getItem('recents_expires_at');

        if (recent_animes) {
            context.commit('setRecentAnimes', JSON.parse(recent_animes));
            context.commit('setRecentsExpiration', recents_expires_at);
        }
    },
    setRecentAnimes(context, recentAnimes) {
        const recent_expires_at = moment().add(60, 'minutes');
        localStorage.setItem('recents_expires_at', recent_expires_at);
        localStorage.setItem('recent_animes', JSON.stringify(recentAnimes));
        context.commit('setRecentAnimes', recentAnimes);
        context.commit('setRecentsExpiration', recent_expires_at);
    },
    loadTriviaAnimes(context) {
        const trivia_animes = localStorage.getItem('trivia_animes');
        const trivia_expires_at = localStorage.getItem('trivia_animes_expires_at');

        if(trivia_animes){
            context.commit('setTriviaAnimes', JSON.parse(trivia_animes));
            context.commit('setTriviaAnimesExpiration', trivia_expires_at);
        }
    },
    setTriviaAnimes(context, animes) {
        const trivia_expires_at = moment().add(24, 'hours');
        localStorage.setItem('trivia_animes_expires_at', trivia_expires_at);
        localStorage.setItem('trivia_animes', JSON.stringify(animes));
        context.commit('setTriviaAnimes', animes);
        context.commit('setTriviaAnimesExpiration', trivia_expires_at);
    }
}